import { Component, signal, OnInit, inject, DestroyRef } from '@angular/core';
import { Router } from '@angular/router';
import { CurrentUserService } from '@/app/common/current-user/current-user.service';
import { FirebaseService } from '@/app/common/firebase/firebase.service';

@Component({
  selector: 'oba-agency-congrats',
  imports: [],
  templateUrl: './agency-congrats.html',
  styleUrl: './agency-congrats.scss',
})
export class AgencyCongrats implements OnInit {

  /** Fireworks overlay removes from DOM after this duration (matches CSS burst cadence). */
  private static readonly FIREWORKS_DURATION_MS = 2000;

  readonly fireworksVisible = signal(true);
  /** Services */
  private currentUserService = inject(CurrentUserService);
  private router = inject(Router);
  private firebaseService = inject(FirebaseService);
  /** Services - END */
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    const fireworksTimerId = window.setTimeout(() => {
      this.fireworksVisible.set(false);
    }, AgencyCongrats.FIREWORKS_DURATION_MS);
    this.destroyRef.onDestroy(() => window.clearTimeout(fireworksTimerId));
  }

  continueToDashboard() {
    console.log('continueToDashboard');
    console.log('currentUserService.focussedAgency: ', this.currentUserService.focussedAgency);

    /**
     * We need to focus the first brand in the list
     */
    // if (this.currentUserService.focussedAgency?.brands && this.currentUserService.focussedAgency.brands.length > 0) {
    //   this.currentUserService.setFocussedBrand(this.currentUserService.focussedAgency.brands[0]);
    // }

    this.currentUserService.onboardingComplete.set(true);

    this.firebaseService.targetUrl = '/dashboard';
    this.firebaseService.launchApplication(this.currentUserService.shoutUser);

    // this.router.navigate(['/dashboard']);
  }
}
